import { combineReducers } from 'redux';
import { formReduxer } from '@brixel-io/brixel-components/dist/form';
import translations from '@brixel-io/brixel-components/dist/Reducer/TranslationsReducer';
import common from './CommonReducer';
import companies from './CompanyReducer';
import user from './UserReducer';
const rootReducer = combineReducers({
    brixelForm: formReduxer,
    translations,
    common,
    companies,
    user,
});
export default rootReducer;
